import React from 'react'

import { Form, Col } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'

export default function Makes({ values }) {
    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Marcas</Form.Label>
                <Dropdown
                    optionLabel="name"
                    optionValue="id"
                    placeholder={values}
                    filter
                    disabled
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
